module.exports = __webpack_public_path__ + "images/4d478b818e6bfe9c8ed445fdd3635060.svg";